'use client'

import useEmblaCarousel from 'embla-carousel-react'
import { createContext, useContext } from 'react'

import { CarouselApi, CarouselOptions, CarouselPlugin } from '../type'

export type CarouselProps = {
  options?: CarouselOptions
  plugins?: CarouselPlugin
  orientation?: 'horizontal' | 'vertical'
  setApi?: (api: CarouselApi) => void
}

type CarouselContextProps = {
  carouselRef: ReturnType<typeof useEmblaCarousel>[0]
  api: ReturnType<typeof useEmblaCarousel>[1]
  selectedIndex: number
  scrollSnaps: number[]
  scrollPrev: () => void
  scrollNext: () => void
  canScrollPrev: boolean
  canScrollNext: boolean
  scrollTo: (index: number) => void
} & CarouselProps

export const CarouselContext = createContext<CarouselContextProps | null>(null)

export const useCarousel = () => {
  const context = useContext(CarouselContext)

  if (!context) {
    throw new Error('useCarousel must be used within a <Carousel />')
  }

  return context
}
